import { combineReducers } from "redux";
import optionChain from "./optionChain";
import optionRecommendations from "./OpRecommendations";
import optionChartGraphReducer from "./optionChainGraph";
import createNamedWrapperReducer from "../../Common/Reducers/wrapperReducer";
import { FnoBanEnum, } from "@adapters/features/Markets/Common/action-interface/fnoBan";
import fnoBan from "../../Common/Reducers/fnoBan";
import drivingMarkerReducer from "./drivingMarket/drivingMarketReducer";
import optionChainTool from "./optionChainTool";
import bseNseExpiry from "./BseNseExpiry";
export default combineReducers({
    optionChain: optionChain,
    optionChainTool: optionChainTool,
    fnoBan: createNamedWrapperReducer(fnoBan, FnoBanEnum.OP),
    optionRecommendations: optionRecommendations,
    optionChartGraphReducer: optionChartGraphReducer,
    drivingMarkerReducer: drivingMarkerReducer,
    bseNseExpiry: bseNseExpiry,
});
